import { useNavigate } from "react-router";
import DocumentPage from "../../components/document-page";
import Button from "../../components/button";
import { FAQ_CATEGORIES } from "./content";
import { openExternalUrl } from "../../utils/telegram";
import { HelpLink, SupportEmail } from "../../common/help";
import styles from "./style.module.css";

function FaqPage() {
  const navigate = useNavigate();

  return (
    <DocumentPage variant="document">
      <h1>Помощь</h1>
      <p className={styles.subtitle}>Ответы на часто задаваемые вопросы</p>

      <div className={styles.categoryList}>
        {FAQ_CATEGORIES.map((category) => (
          <button
            key={category.slug}
            type="button"
            className={styles.categoryRow}
            onClick={() => navigate(`/faq/${category.slug}`)}
          >
            {category.title}
          </button>
        ))}
      </div>

      <div className={styles.supportCard}>
        <div className={styles.supportTitle}>Нужна помощь?</div>
        <p className={styles.supportText}>
          Свяжитесь с нами в Telegram или отправьте письмо на{" "}
          <a href={`mailto:${SupportEmail}`}>{SupportEmail}</a>
        </p>
        <Button label="Написать в Telegram-чат" onClick={() => openExternalUrl(HelpLink)} />
      </div>
    </DocumentPage>
  );
}

export default FaqPage;
